class KingsCart extends HTMLElement {
  constructor(){
    super();
    this.items = [];
  }

  connectedCallback() {
    this.getSelectors();
    this.assignEvents();

  }

  getSelectors(){
    this.items = [...this.querySelectorAll('.main-cart__list-item')];
  }

  assignEvents(){
    this.items.map((item) => {
      let quantityBox = item.querySelector('.main-cart__list-item-quantity');
      let buttonM = quantityBox.querySelector('[data-action="reduce"]'); 
      let buttonP = quantityBox.querySelector('[data-action="enlarge"]'); 
      let input   = quantityBox.querySelector('[name="quantity"]');

      let remove = item.querySelector('.js-remove-main-cart__list-item');
      remove.addEventListener('click', this.onRemove.bind(this));

      buttonM.addEventListener('click', this.onChangeQta.bind(this));
      buttonP.addEventListener('click', this.onChangeQta.bind(this));
      input.addEventListener('change', this.onChangeInput.bind(this));
    });
  }

  onRemove(event){
    let { target } = event;
    let button = target.closest('button');
    let key = button.getAttribute('data-id');
    this.updateCart(key, 0);
  }

  updateSection(section){
    let newHtml = this.stringToHTML(section);
    let newSection = newHtml.querySelector('kings-cart').innerHTML;
    this.innerHTML = newSection;
    setTimeout(function(){
      this.getSelectors();
      this.assignEvents();
    }.bind(this), 800);
  }

  onChangeInput(event){
    let { target } = event;
    let key = target.getAttribute('data-id');
    let qta = parseInt(target.getAttribute('value'));
    this.updateCart(key, qta);
  }

  stringToHTML(str) {
    // If DOMParser is supported, use it
    if (this.supportDOMParser()) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(str, 'text/html');
      return doc.body;
    }

    // Otherwise, fallback to old-school method
    const dom = document.createElement('div');
    dom.innerHTML = str;
    return dom;
  }

  supportDOMParser() {
    if (!window.DOMParser) return false;

    const parser = new DOMParser();

    try {
      parser.parseFromString('x', 'text/html');
    } catch (err) {
      return false;
    }

    return true;
  }

  onChangeQta(event){
    let { target } = event;
    let btn = target.closest('button');
    let action = btn.getAttribute('data-action');
    let input = btn.parentElement.querySelector('input');
    
    let current = parseInt(input.getAttribute('value'));
    let qta = 0;
    if(action == 'reduce'){
      qta = current-1;
    } else {
      qta = current+1;
    }

    input.setAttribute('value', qta);

    let ev = new Event('change');
    input.dispatchEvent(ev);
  }

  async updateCart(lineitemId, quantity) {
    let request = await fetch('/cart/change.js', {
      body: JSON.stringify({
        id: lineitemId,
        quantity: quantity,
        sections: 'main-cart'
      }),
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With':'xmlhttprequest' /* XMLHttpRequest is ok too, it's case insensitive */
      },
      method: 'POST'
    });

    let response = await request.json();
    this.updateSection(response['sections']['main-cart']);
  }
}

window.customElements.define('kings-cart', KingsCart);